import type { SimState } from '../sim/sim';

export const DEFEAT_SECONDS = 2;

/** Presentation advances independently; the authoritative winning snapshot remains frozen. */
export function nextDefeatAge(age: number, won: boolean, dt: number, paused: boolean, reducedMotion: boolean): number {
  if (!won) return 0;
  return reducedMotion ? DEFEAT_SECONDS : Math.min(DEFEAT_SECONDS, age + (paused ? 0 : Math.max(0, dt)));
}

export function bossDeathAge(sim: SimState, presentationAge?: number): number | null {
  return sim.wonAt === null ? null : (presentationAge === undefined ? sim.t - sim.wonAt : Math.max(0, presentationAge));
}
